import React from "react";
import { Helmet } from "react-helmet";
import { useLocation, useRoutes } from "react-router-dom";

import { appRoutes } from "routes";
import { useLocalize } from "hooks";

import AppNavbar from "components/navbar/navbar";
import Footer from "components/footer/footer";
import { ToastContainer } from "react-toastify";
import { useAuthContext } from "store/auth";
import NavigatorNavbar from "components/navbar/navigator-navbar";

const App = () => {
  const { pathname } = useLocation();
  const routes = useRoutes(appRoutes);
  const { stylePath } = useLocalize();
  const [{ isLoggedIn }] = useAuthContext();

  React.useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <div className="App">
      <Helmet>
        <link rel="stylesheet" type="text/css" href={stylePath} />
      </Helmet>
      <ToastContainer position="top-center" autoClose={1000} theme="dark" limit={1} hideProgressBar />
      {isLoggedIn ? <AppNavbar /> : <NavigatorNavbar />}
      <div className="container-fluid">{routes}</div>
      <Footer />
    </div>
  );
};

export default App;
